import React from 'react';

export const PencilIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M22.19 1.81001C21.502 1.1249 20.5686 0.743175 19.5977 0.749748C18.6268 0.756321 17.6987 1.15065 17.02 1.84501L2.52 16.345L0.75 23.25L7.655 21.479L22.155 6.97901C22.8496 6.30062 23.244 5.37268 23.2506 4.40181C23.2572 3.43095 22.8753 2.49775 22.19 1.81001Z" stroke="#353950" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.606 2.26001L21.74 7.39401" stroke="#353950" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.521 16.344L7.66 21.474" stroke="#353950" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
